<template>
    <b-modal
        id="file-edit-modal"
        v-model="modal"
        ref="fileEditModal"
        :title="$t('group.internship.edit_file')"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        @ok="onOk"
        modal-class="apprentice-default-modal"
        size="md">
        <div class="file-edit">
            <div
                class="error"
                v-if="hasError">
                <b-alert
                    show
                    variant="danger">
                    {{ $t('group.internship.file_name_cannot_be_empty_or_end_with_a_special_character') }}
                </b-alert>
            </div>
            <div class="file-edit-name">
                <label for="file-name-edit">{{ $t('common.name') }}</label>
                <b-input-group
                    size="lg"
                    :append="`.${extension}`">
                    <b-form-input
                        id="file-name-edit"
                        v-model="name"
                        :placeholder="$t('group.internship.type_a_file_name')">
                    </b-form-input>
                </b-input-group>
            </div>

            <div class="file-edit-description">
                <b-form-group
                    :label="$t('common.description')"
                    label-for="upload-file-description">
                    <b-form-input
                        id="upload-file-description"
                        v-model="description"
                        :placeholder="$t('group.internship.fill_in_a_description')">
                    </b-form-input>
                </b-form-group>
            </div>

            <div class="file-edit-visibility">
                <b-form-group
                    :label="$t('group.internship.visibility')"
                    label-for="file-visibility-edit">
                    <b-form-select
                        class="apprentice-primary-select file-upload"
                        id="file-visibility-edit"
                        v-model="visibility"
                        :options="visibilityOptions">
                    </b-form-select>
                </b-form-group>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-group-show-file-edit-modal-component',
    data() {
        return {
            name: '',
            extension: '',
            description: '',
            visibility: 0,
            visibilityOptions: [
                {
                    value: 0,
                    text: this.$t('group.internship.students_and_teachers'),
                },
                {
                    value: 1,
                    text: this.$t('group.internship.only_teachers'),
                },
            ],
            modal: false,
            hasError: false,
        };
    },
    methods: {
        show(file) {
            this.fileId = file.id;
            this.name = file.name.split('.')[0];
            this.extension = file.name.split('.').pop();
            this.description = file.description;
            this.visibility = file.visibility;
            this.modal = true;
        },

        onOk(bvModalEvent) {
            this.hasError = false;
            const spChars = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
            if (this.name === '' || spChars.test(this.name)) {
                this.hasError = true;
                bvModalEvent.preventDefault();
                return;
            }

            const data = {
                id: this.fileId,
                name: this.name,
                description: this.description,
                visibility: this.visibility,
            };

            this.$emit('file-update', data);
        },
    },
};
</script>

<style scoped lang="scss">
.file-edit {
    div {
        &:not(:last-child) {
            margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
        }

        select,
        input {
            margin-bottom: 0;
            font-size: $default-font-size;
        }

        input {
            padding: map-get($grid-gutter-spacing, 'fifteen') map-get($grid-gutter-spacing, 'ten');
            height: auto;
            border-radius: 12px;
        }

        .input-group-text {
            font-size: $default-font-size;
            border-top-right-radius: 12px;
            border-bottom-right-radius: 12px;
            padding: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}
</style>
